export default "__VITE_ASSET__016e1256__"